module.exports = __webpack_public_path__ + "static/img/1604_phase_function_Paper_PointsHejduk_Prediction.a08154c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1604_phase_function_Paper_PointsHejduk_Prediction.png
// module id = YIOA
// module chunks = 0